import styled from '@emotion/styled';
import {MainTitleDark as MainTitleDarkUI} from 'ui';

export const MainTitleDark = styled(MainTitleDarkUI)({
  marginBottom: 16,
  marginTop: 30,
  fontSize: 26,
});

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});
